import React from 'react';
import { capitalize, Stack } from '@mui/material';
import { InputField } from 'components/form';
import { useFormContext } from 'react-hook-form';
import { ListingForm } from 'components/shared/TableListing';

import { AttributeFieldProps, StagesFormValues } from '../../../../../types';
import { AttributeRequiredNode } from './AttributeRequiredNode';

export const ChecklistField = (props: AttributeFieldProps) => {
  const { rowIndex, attributeIndex, prefix, disabled } = props;

  const { control } = useFormContext<ListingForm<StagesFormValues>>();

  return (
    <Stack gap="0.5rem" width="100%">
      <InputField
        control={control}
        label="Checklist Field Name"
        name={`bodyFields.${rowIndex}.${prefix}.${attributeIndex}.name`}
        inputProps={{
          disabled,
          required: true,
          variant: 'outlined',
          placeholder: `${capitalize(prefix)} field name`,
        }}
      />

      <AttributeRequiredNode {...props} />
    </Stack>
  );
};
